import { Code2, Mail, MessageCircle, Smartphone, Phone } from 'lucide-react';
import type { Ticket, TicketChannel, TicketPriority, TicketStatus } from '@/api/types';
import { Badge } from '@/components/ui';
import { cn } from '@/lib/cn';
import { CHANNEL_LABEL, PRIORITY_LABEL, PRIORITY_TONE, STATUS_LABEL, STATUS_TONE, slaState } from './meta';

export function StatusBadge({ status }: { status: TicketStatus }) {
  return (
    <Badge tone={STATUS_TONE[status]} dot>
      {STATUS_LABEL[status]}
    </Badge>
  );
}

export function PriorityBadge({ priority }: { priority: TicketPriority }) {
  return <Badge tone={PRIORITY_TONE[priority]}>{PRIORITY_LABEL[priority]}</Badge>;
}

const CHANNEL_ICON = {
  email: Mail,
  chat: MessageCircle,
  app: Smartphone,
  whatsapp: Phone,
  api: Code2,
} as const;

export function ChannelIcon({ channel, className }: { channel: TicketChannel; className?: string }) {
  const Icon = CHANNEL_ICON[channel];
  return (
    <span title={CHANNEL_LABEL[channel]} className="inline-flex">
      <Icon className={cn('h-3.5 w-3.5 text-slate-400', className)} aria-hidden />
      <span className="sr-only">{CHANNEL_LABEL[channel]}</span>
    </span>
  );
}

export function SlaBadge({ ticket }: { ticket: Pick<Ticket, 'slaDueAt' | 'status'> }) {
  const sla = ticket.status === 'open' ? slaState(ticket) : null;
  if (!sla) return null;
  return <Badge tone={sla.tone}>{sla.label}</Badge>;
}
